export function getCommunesFromCityCode(cityCode, communes) {
  const commune = communes?.find(com => com.code === cityCode);
  return commune;
}
